import { z } from 'zod';

/**
 * NB!
 * If you need to change the schema, please also update the backend repository as it uses the same schema.
 * Otherwise the backend will reject the requests.
 */

const normalizeSpaces = (value: string): string => {
  return value.trim().replace(/\s+/g, ' ');
};

export const itemSchema = z.object({
  title: z.string().min(1),
  text: z.string().min(1),
});

export const fullNameSchema = z
  .string()
  .refine((value) => /^[^\s]+(\s+[^\s]+)+$/.test(normalizeSpaces(value)))
  .transform((value) => normalizeSpaces(value));

export const schema = z.object({
  name: z.string().min(1),
  date: z.string().min(1),
  time: z.string().min(1),
  location: z.string().min(1),
  participants: z.coerce.number().min(2),
  items: z.array(itemSchema).min(1),
  chairperson: fullNameSchema,
  secretary: fullNameSchema,
  signatoryConfirmation: z.boolean().refine((val) => val === true),
});

export type MeetingMinutesFormState = z.infer<typeof schema>;
